module.exports = __webpack_public_path__ + "55ab4330a169279f78d704cdcbb513f9.svg";